import { render, staticRenderFns } from "./ResultBest.vue?vue&type=template&id=6c7123ea&scoped=true&"
import script from "./ResultBest.vue?vue&type=script&lang=js&"
export * from "./ResultBest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7123ea",
  null
  
)

export default component.exports